import { Dialog } from '@mui/material';
import { Box } from '@mui/system';
import { FC, ReactNode, useCallback } from 'react';
import { DialogContent, DialogSubTitle, DialogTitle } from '../../../shared/dialog/dialog.styles';
import { LoadingOverlay } from '../../../shared/loading-overlay/loading-overlay';
import { usePatientIvStatusDialog } from '../hooks/use-patient-iv-status-dialog/hook';

export interface PatientIvStatusDialogProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  opened: boolean;
  children?: ReactNode;
}

export const PatientIvStatusDialog: FC<PatientIvStatusDialogProps> = (props) => {
  const { opened, title, subtitle, children } = props;
  const { isReady, selectedIvSummary, patientFlow, verificationPriority, patientInfo } = usePatientIvStatusDialog();

  const getInsuranceLabel = useCallback(() => {
    if (!patientFlow?.patientIvSummary?.secondaryVerificationSummary) return 'Insurance:';

    if (verificationPriority === 'Primary') return 'Primary Insurance:';

    if (verificationPriority === 'Secondary') return 'Secondary Insurance:';

    return 'Insurance:';
  }, [selectedIvSummary, patientFlow]);

  return (
    <Dialog open={opened} maxWidth={false}>
      <DialogContent>
        {title && <DialogTitle>{title}</DialogTitle>}
        {subtitle && <DialogSubTitle>{subtitle}</DialogSubTitle>}
        {selectedIvSummary && (
          <>
            <DialogSubTitle>
              <Box sx={{ fontWeight: 500 }}>{getInsuranceLabel()}</Box>&nbsp;
              {selectedIvSummary.carrierName || selectedIvSummary.idPayer || (verificationPriority === 'Secondary' ? patientInfo?.secondaryInsuranceInfo?.carrierId : patientInfo?.insuranceInfo?.carrierId) || '<Unknown>'}
            </DialogSubTitle>
            <DialogSubTitle>
              <Box sx={{ fontWeight: 500 }}>Member ID:</Box>&nbsp;
              {(verificationPriority === 'Secondary' ? patientInfo?.secondaryInsuranceInfo?.memberId : patientInfo?.insuranceInfo?.memberId) || '<Unknown>'}
            </DialogSubTitle>
          </>
        )}
        {children}
      </DialogContent>
      <LoadingOverlay isLoading={!isReady} />
    </Dialog>
  );
};
